<script setup>
import { onErrorCaptured } from 'vue';
import { RouterView } from 'vue-router';
import ToastHost from './components/ToastHost.vue';
import { useUiStore } from './stores/ui.js';

const ui = useUiStore();

onErrorCaptured((error) => {
  console.error(error);
  ui.toast('Не удалось отобразить часть интерфейса', 'error');
  return false;
});
</script>

<template>
  <RouterView />
  <ToastHost />
</template>
